import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalabandoned-card',
  templateUrl: './helpbutton-reports-totalabandoned-card.component.html',
  styleUrls: ['./helpbutton-reports-totalabandoned-card.component.scss']
})
export class HelpbuttonReportsTotalabandonedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
